import React from 'react';
import HomeRedirect from '@/routes/HomeRedirect';
import LogoutContainer from '@/containers/LogoutContainer';
import Selectors from '../hooks/selectors';

const LogoutPage = () => {
  const { commonsMode, isAuthenticatedUser } = Selectors.useLogoutPage();
  return (<>{(isAuthenticatedUser || commonsMode) ? <HomeRedirect /> : <LogoutContainer />}</>);
};

export default LogoutPage;
